import Controller, { OnUnmount } from '@philips-internal/oswald-ui-core/lib/client';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import BaseController from '../BaseController';

@Controller({ fragment: 'root-pep' })
class RootPepController extends BaseController {

  @OnUnmount({ target: 'main-layout'})
  onMainLayoutUnMount(): void {
    applicationContext.closeModules();
    applicationContext.clearNavigationStack();
  }
}

export default RootPepController;